import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-notification-toast',
  imports: [MatIconModule, MatButtonModule, TranslateModule],
  templateUrl: './notification-toast.component.html',
  styleUrl: './notification-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationToastComponent {
  readonly snackBarRef = inject(MatSnackBarRef<NotificationToastComponent>);
  readonly data = inject<{ icon: string; labelKey: string; labelParams?: Record<string, unknown> }>(MAT_SNACK_BAR_DATA);
}
